export const Button = {
  baseStyle: {
    fontWeight: "normal",
  },
}
